


























































































































































































































































































































































































































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';

type Group = I.AxZone;

type PageInfo = I.MealCashPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<CardList | CashList, State>;

type CardDataStore = U.DataStore<CardList>;
type CashDataStore = U.DataStore<CashList>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

enum MealSearchType {
  All = 'TO',
  Card = 'OD',
  Edit = 'ED'
}

class State {
  listDoor: I.CodeData[];
  listMealType: I.CodeData[];

  mealEdit: MealSearchType;

  empno: string;
  userName: string;
  cardNo: string;
  category: number;

  beginDate: string;
  beginDateMenu: boolean;
  endDate: string;
  endDateMenu: boolean;

  constructor() {
    this.listDoor = [];
    this.listMealType = [];

    this.mealEdit = MealSearchType.All;

    this.empno = '' as never;
    this.userName = '' as never;
    this.cardNo = '' as never;
    this.category = 0;

    this.beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.beginDateMenu = false;
    this.endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.endDateMenu = false;
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

enum TabKind {
  Card,
  Cash
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
  dialogState!: DialogState;
  currentTab!: TabKind;
  zoneCode!: number;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.meal.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchCard(packet: I.PacketMealCardSearch) {
    this.setLoading(true);
    const result = await this.API.call.meal.mealCardSearch(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchCash(packet: I.PacketMealCashSearch) {
    console.log('packet', packet);
    this.setLoading(true);
    const result = await this.API.call.meal.mealCashSearch(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async CardEventSave(packet: I.PacketMealCardSave) {
    console.log('packet', packet);
    this.setLoading(true);
    const result = await this.API.call.meal.mealCardSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async CashEventSave(packet: I.PacketMealCashSave) {
    console.log('packet', packet);
    this.setLoading(true);
    const result = await this.API.call.meal.mealCashSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: new DataStore<CardList>({
        headers: {
          num: { text: '순번', sortable: false },
          mealEdit: '구분',
          doorName: '리더기',
          empNo: '사원번호',
          empName: '성명',
          eventTime: '날짜',
          mealName: '식수유형',
          mealcnt: '수량',
          mealprice: '금액',
          companyName: '회사명',
          deptNameA: '사업장',
          deptNameB: '부서',
          rEDate: '저장시간'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '현금',
      store: new DataStore<CashList>({
        headers: {
          num: { text: '순번', sortable: false },
          eDate: '날짜',
          doorName: '리더기',
          mealName: '식수유형',
          mealcnt: '수량',
          mealprice: '가격',
          eventTime: '저장시간'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[this.currentTab];
  }
}

@Component
class DialogHandler extends BaseClass {
  showMealTypeSelectDialog() {
    this.showCodeSelectDialog({
      title: '식수 유형 선택',
      param: {
        items: this.pageInfo.listMealType,
        selected: this.dataItem.state.listMealType,
        callback: async (selected: I.CodeData[]) => {
          this.dataItem.state.listMealType = selected;
        }
      }
    });
  }

  showReaderSelectDialog() {
    const listDoorCode: I.CodeData[] = this.pageInfo.listDoor
      .filter(x => x.zoneCode === this.zoneCode)
      .map(x => {
        return {
          code: x.code.toString(),
          name: x.name
        };
      });

    this.showCodeSelectDialog({
      title: '리더기 선택',
      param: {
        items: listDoorCode,
        selected: this.dataItem.state.listDoor,
        callback: async (selected: I.CodeData[]) => {
          this.dataItem.state.listDoor = selected || [];
        }
      }
    });
  }

  showEmployeeSearchDialog() {
    type EmployeeSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<EmployeeSearchDialogParams>(
      'AxSearchMealEmployeeDialog',
      {
        param: {
          items: [],
          selected: [],
          callback: async () => {
            const selected = dialogParams.props.param.selected[0] as I.User;
            if (!selected) return;

            this.dataItem.state.empno = selected.empno;
            this.dataItem.state.userName = selected.name;
          }
        }
      }
    );
    this.showDialog(dialogParams);
  }

  // 카드 추가
  async showMealManualNewCard() {
    const zoneCode = this.zoneCode;
    const currentKind = 0;
    const callback = async () => {
      await ((this as unknown) as MealManual).onSearchEvent();
    };

    this.showDialog({
      type: 'AxMealManualNewDialog',
      props: {
        zoneCode,
        currentKind,
        callback
      }
    });
  }

  // 현금 추가
  async showMealManualNewCash() {
    const zoneCode = this.zoneCode;
    const currentKind = 1;
    const callback = async () => {
      await ((this as unknown) as MealManual).onSearchEvent();
    };

    this.showDialog({
      type: 'AxMealManualNewDialog',
      props: {
        zoneCode,
        currentKind,
        callback
      }
    });
  }

  //카드 엑셀 업로드
  async showMealExcelUpload() {
    const zoneCode = this.zoneCode;
    const currentKind = 0;
    const callback = async () => {
      await ((this as unknown) as MealManual).onSearchEvent();
    };

    this.showDialog({
      type: 'AxMealExcelUploadDialog',
      props: {
        zoneCode,
        currentKind,
        callback
      }
    });
  }
}

@Component
export class DateHandler extends BaseClass {
  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;
  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;
}

@Component
class ExcelExportHandler extends Mixins(AxPage) {
  dataItem!: DataItem;

  async onExportExcelConfirm(prefix: string) {
    if (!this.dataItem.description.length) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };

      moment.locale('ko');
      const momentTime = moment(Date.now());
      const outputPrefix = `${prefix.replace(/\s/g, '_')}_${this.dataItem.name.replace(
        /\s/g,
        ''
      )}_`;

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      const headers = this.dataItem.store.getHeaders();

      // 엑셀 내보내기시 수작업으로 순번 필드를 만드므로 순번 필드를 삭제시킨다
      const headerEntries = Object.entries(headers).filter(x => x[0] !== 'num');
      const headerKeys = headerEntries.map(x => x[0]);
      const headerValues = headerEntries.map(x => x[1]);

      if (!headers) {
        await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
        return;
      }

      // 헤더 작성 (식수 조회 [사원별] 등등..)
      const headerSize = headerKeys.length;
      worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
      worksheet.getCell('A1').value = `${prefix} [${this.dataItem.name}]`;
      worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      let row = 2;

      // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
      // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
      this.dataItem.description.forEach(x => {
        worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
        worksheet.getCell(`A${row++}`).value = x;
      });

      // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다

      worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
      worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

      worksheet.insertRow(
        row,
        [
          'No.',
          ...headerValues.map(x => {
            if (typeof x === 'string') return x;
            else {
              const y = (x as unknown) as { [key: string]: unknown };
              if (y.text) {
                return y.text;
              } else {
                return y;
              }
            }
          })
        ],
        'i'
      );
      const headerRow = row++;
      // 테두리 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.style = {};
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 아이템 필터. Header에 들어간 item만 뽑는다
      this.dataItem.store.getItems().forEach((x, idx) => {
        const arr: unknown[] = [idx + 1];
        headerKeys.forEach(y => {
          if (y === 'eventTime') {
            arr.push(this.formatTime(((x as unknown) as { [key: string]: string })[y]));
          } else {
            arr.push(((x as unknown) as { [key: string]: unknown })[y]);
          }
        });
        worksheet.insertRow(row++, arr, 'i');
      });

      // 헤더 라인에 음영 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' },
          bgColor: { argb: 'FFFFFF00' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  currentTab = TabKind.Card;
  dialogState = new DialogState();

  pageInfo = {} as PageInfo;
  zoneCode = 0;

  revertZone = false;
  dates = [];

  dialog = false;

  get empNoWithName() {
    if (!this.dataItem.state.userName || !this.dataItem.state.empno) return;
    return `${this.dataItem.state.userName} (${this.dataItem.state.empno})`;
  }
}

// vue-class-component의 mixins는 생성자가 5개 이상 넘어가면 unknown으로 캐스팅됨
// 이를 방지하기 위해서 여러 클래스를 분할하는 Mixin 패턴을 사용하려면
// 클래스를 5개씩 끊어서 넣어줘야 한다
const Handlers = Mixins(
  Mixins(ApiHandler, DataItemHandler, DateHandler, DialogHandler),
  Mixins(ExcelExportHandler)
);

@Component
export default class AxMealManualDialog extends Mixins(BaseData, Handlers, AxPage) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }

    await this.onSearchEvent();
  }

  async onSearchEvent() {
    switch (this.currentTab) {
      case TabKind.Card:
        {
          const result = await this.onCardSearchEvent();
          if (!result) return;

          this.dataItem.store.setItems(result);
        }
        break;
      case TabKind.Cash:
        {
          const result = await this.onCashSearchEvent();
          if (!result) return;

          this.dataItem.store.setItems(result);
        }
        break;
    }
  }

  dates = [];

  makeCardPacket(): I.PacketMealCardSearch {
    return {
      zoneCode: this.zoneCode,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: '0000',
      searchTimeTo: '2359',
      hourFrom: '',
      minuteFrom: '',
      hourTo: '',
      minuteTo: '',
      listDoorCode: this.dataItem.state.listDoor,
      listMealType: this.dataItem.state.listMealType,
      empName: this.dataItem.state.userName,
      empNo: this.dataItem.state.empno,
      mealEdit: this.dataItem.state.mealEdit
    };
  }

  async onCardSearchEvent() {
    this.setLoading(true);
    const result = await this.searchCard(this.makeCardPacket());
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result;
    }
  }

  makeCashPacket(): I.PacketMealCashSearch {
    return {
      zoneCode: this.zoneCode,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: '0000',
      searchTimeTo: '2359',
      hourFrom: '',
      minuteFrom: '',
      hourTo: '',
      minuteTo: '',
      listDoorCode: this.dataItem.state.listDoor,
      listMealType: this.dataItem.state.listMealType
    };
  }

  async onCashSearchEvent() {
    this.setLoading(true);
    const result = await this.searchCash(this.makeCashPacket());
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result;
    }
  }

  async onClearClicked() {
    const result = await this.showConfirmModal('확인', '검색 조건을 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onRowItemClicked(item: I.MealCardData | I.MealCashData) {
    if (this.currentTab === TabKind.Card) {
      const cardItem = item as I.MealCardData;
      const result = await this.showConfirmModal(
        '확인',
        `사원번호 : ${cardItem.empNo}<br />성명 : ${cardItem.empName}<br />식수유형 : ${cardItem.mealName}<br /><br />선택된 내역을 삭제하시겠습니까?`
      );
      if (result === 0) {
        this.onCardEditDeleted(cardItem.seqNo);
      }
    }

    if (this.currentTab === TabKind.Cash) {
      const cashItem = item as I.MealCashData;
      const result = await this.showConfirmModal(
        '확인',
        `리더기명 : ${cashItem.doorName}<br />식수유형 : ${cashItem.mealName}<br /><br />선택된 내역을 삭제하시겠습니까?`
      );
      if (result === 0) {
        this.onCashEditDeleted(cashItem.seqNo);
      }
    }
  }

  async makeMealCardPacket(seq: number): Promise<I.PacketMealCardSave | undefined> {
    return {
      seqNo: seq,
      doorID: 1,
      userID: 1,
      updateIndex: 1,
      eventTime: U.formatTime(new Date().toISOString(), 'YYYY-MM-DD'),
      eventCode: 200,
      mealCode: 1,
      mealCnt: 1,
      mealPrice: 1,
      eDate: U.formatTime(new Date().toISOString(), 'YYYY-MM-DD'),
      rEDate: U.formatTime(new Date().toISOString(), 'YYYY-MM-DD'),
      updateFlag: 'D'
    };
  }

  async onCardEditDeleted(seq: number) {
    const packet = await this.makeMealCardPacket(seq);
    if (!packet) return;

    this.setLoading(true);
    const result = await this.CardEventSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('정보', '삭제 되었습니다.');
      await this.onSearchEvent();
      return result;
    }
  }

  async makeMealCashPacket(seq: number): Promise<I.PacketMealCashSave | undefined> {
    return {
      seqNo: seq,
      doorID: 1,
      eventTime: U.formatTime(new Date().toISOString(), 'YYYY-MM-DD'),
      eventCode: 200,
      mealCode: 1,
      mealCnt: 1,
      mealPrice: 1,
      eDate: U.formatTime(new Date().toISOString(), 'YYYY-MM-DD'),
      updateFlag: 'D'
    };
  }

  async onCashEditDeleted(seq: number) {
    const packet = await this.makeMealCashPacket(seq);
    if (!packet) return;

    this.setLoading(true);
    const result = await this.CashEventSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('정보', '삭제 되었습니다.');
      await this.onSearchEvent();
      return result;
    }
  }

  // v-dialog Start
  on = true;

  state = new State();

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '1200px' })
  width!: string;

  @Prop({ type: String, default: '800px' })
  height!: string;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  // v-dialog End
}
